import { useMemo } from 'react';
import { keyBy } from 'es-toolkit';
// components
import SystemOutput from '@/modules/Analytics/components/SystemOutput';
import Toolbar from '@/modules/Analytics/components/Toolbar';
// utils
import { usePersonasQuery } from '@/services/bff/bff.queries.ts';
import useAnalyticsStore from '@/modules/Analytics/Analytics.store.ts';
// assets
import styles from '@/modules/Analytics/components/LogsPanel/LogsPanel.module.css';

const LogsPanel = () => {
    const filters = useAnalyticsStore((state) => state.filters);
    const { data, isFetching: isAgentsFetching } = usePersonasQuery({
        page: 1,
        per: 100,
        is_linked_to_agent: true
    });

    const agentsHash = useMemo(
        () => keyBy(data?.items ?? [], (a) => a.id),
        [data?.items]
    );
    return (
        <div className={styles.panel}>
            <Toolbar filters={filters} />
            <SystemOutput
                agents={agentsHash}
                isAgentsFetching={isAgentsFetching}
                searchTerm={filters.message}
            />
        </div>
    );
};

export default LogsPanel;
